import React, { useEffect, useState } from "react";
import { CancelTokenSource } from "axios";
import { Modal } from "react-bootstrap";
import { RouteComponentProps } from "react-router";
import useFlash from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import { apiOrganization } from "../../../../../../../../../services/Api/Organization/apiOrganization";
import {
	ApplicationApi,
	ApplicationProvider,
	ApplicationTemplateApi,
} from "../../../../../../../../../services/Api/Organization/types";
import { AppModalViewMode, AppState } from "../../../utils/types";
import InstallationAppForm from "../InstallationAppForm";
import AppModalHeader from "./AppModalHeader";
import AppModalBody from "./ModalBody/AppModalBody";

interface Props {
	onHide: () => void;
	configApp: ApplicationTemplateApi;
	installedApp?: ApplicationApi;
	viewType?: AppModalViewMode;
	handleUninstall?: (app: ApplicationApi) => void;
	handleUpdate?: (app: ApplicationApi) => void;
	handleUpdateNewInstalledApp?: (app: ApplicationApi) => void;
	routeProps?: RouteComponentProps;
	setShowParentModal?: React.Dispatch<React.SetStateAction<boolean>>;
}

const AppModal = ({
	onHide,
	configApp,
	installedApp,
	viewType,
	handleUninstall,
	handleUpdate,
	routeProps,
	handleUpdateNewInstalledApp,
	setShowParentModal,
}: Props) => {
	const [showModal, setShowModal] = useState(true);
	const [appConfigForInstallationModal, setAppConfigForInstallationModal] = useState<
		ApplicationTemplateApi | undefined
	>();
	const { addFlash } = useFlash();
	const [appState, setAppState] = useState<AppState | undefined>(undefined);

	useEffect(() => {
		fetchApplication();
	}, []);

	const fetchApplication = async (cancelToken?: CancelTokenSource) => {
		if (installedApp) {
			const params: Record<string, any> = { include: "settings" };

			try {
				const [app, config, pointsOfSale] = await Promise.all([
					apiOrganization.getApp(installedApp.id, params, {
						cancelToken: cancelToken?.token,
					}),
					apiOrganization.getAppsConfig(Number(installedApp.id), {
						cancelToken: cancelToken?.token,
					}),
					installedApp.provider === ApplicationProvider.GOORDER
						? apiOrganization.getPointsOfSaleSearchSelect("", { size: 10, page: 0 })
						: undefined,
				]);
				setAppState({
					app,
					config,
					showPointsOfSale: pointsOfSale && pointsOfSale.length > 0,
				});
			} catch (err) {
				handleError.alert(err, addFlash);
			}
		}
	};

	return (
		<>
			{appConfigForInstallationModal && (
				<InstallationAppForm
					show={!!appConfigForInstallationModal}
					onHide={() => {
						setAppConfigForInstallationModal(undefined);
						setShowParentModal?.(false);
					}}
					appConfig={appConfigForInstallationModal}
				/>
			)}
			<Modal className={"app-modal"} size={"lg"} show={showModal} onHide={onHide}>
				<AppModalHeader configApp={configApp} installedApp={installedApp} onHide={onHide} appState={appState} />
				<AppModalBody
					appState={appState}
					configApp={configApp}
					installedApp={installedApp}
					setAppConfigForInstallationModal={setAppConfigForInstallationModal}
					routeProps={routeProps}
					viewType={viewType}
					handleUpdateNewInstalledApp={handleUpdateNewInstalledApp}
					setShowModal={setShowModal}
					setAppState={setAppState}
					handleUninstall={handleUninstall}
					handleUpdate={handleUpdate}
					fetchApplication={fetchApplication}
					setShowParentModal={setShowParentModal}
				/>
			</Modal>
		</>
	);
};
export default AppModal;
